<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{dialogTitle}}</span>
            <button mat-icon-button (click)="matDialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>

        <form [formGroup]="supplierForm" fxLayout="column" fxLayoutAlign="start"
              fxFlex="1 0 auto">

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                    <mat-label>{{'Name'|translate}}</mat-label>
                    <input matInput formControlName="name" required>
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    <mat-error>{{'Name is required!'|translate}}</mat-error>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                    <mat-label>{{'E-mail'|translate}}</mat-label>
                    <input matInput formControlName="email">
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                    <mat-label>{{'Phone'|translate}}</mat-label>
                    <input matInput formControlName="phone">
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                    <mat-label>{{'Contact person'|translate}}</mat-label>
                    <input matInput formControlName="contactPerson">
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{'Description'|translate}}</mat-label>
                    <textarea matInput formControlName="description"></textarea>
                </mat-form-field>
            </div>

        </form>

    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button *ngIf="action === 'edit'"
                mat-button
                class="mr-8"
                (click)="matDialogRef.close(['delete',supplierForm])"
                aria-label="Delete"
                matTooltip="Delete">
            {{'DELETE'|translate}}
        </button>

        <button *ngIf="action !== 'edit'"
                mat-button
                class="save-button"
                color="primary"
                (click)="matDialogRef.close(supplierForm)"
                [disabled]="supplierForm.invalid"
                aria-label="SAVE">
            {{'ADD'|translate}}
        </button>

        <button *ngIf="action === 'edit'"
                mat-button
                class="save-button"
                (click)="matDialogRef.close(['save',supplierForm])"
                [disabled]="supplierForm.invalid"
                aria-label="SAVE">
            {{'SAVE'|translate}}
        </button>

    </div>
</div>
